import { render, staticRenderFns } from "./document-automation-request-card.vue?vue&type=template&id=44efef42"
import script from "./document-automation-request-card.vue?vue&type=script&lang=ts"
export * from "./document-automation-request-card.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports